import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ConfirmationService} from 'primeng/api';

import {AuthUser, TokenService} from '../../../../core/auth';
import {Customer} from '../../../../core/models/';
import {CustomerService} from '../../../../core/services/';
import {BreadcrumbService} from '../../../../breadcrumb.service';


@Component({
  selector: 'app-customer-creation',
  templateUrl: './customer-creation.page.html'
})
export class CustomerCreationPage implements OnInit {
  @Input() customer: Customer;
  saving = false;
  authUser: AuthUser = this.token.whoAmI();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private confirmationService: ConfirmationService,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin', 'dashboard']},
      {label: 'customer', routerLink: ['/admin', 'customer', 'list']},
      {label: 'new'},
    ]);
  }

  ngOnInit() {
    this.customer = new Customer();
  }


  backToList() {
    this.router.navigate(['/admin', 'customer', 'list']);
  }

  saveCustomer() {
    this.saving = true;
    this.createCustomer(this.customer);
  }

  createCustomer(customer: Customer) {
    this.customerService.create(customer)
      .subscribe(
        (data) => {
          this.backToList();
          delete (this.saving);
        },
        (error) => {
          delete (this.saving);
        }
      );
  }

}
